import React from 'react';
import { BoxAnnotation } from './types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  svg: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
}));

interface MediaViewerBoxOrderingProps {
  boxAnnotations: BoxAnnotation[];
  imageHeight: number;
  imageWidth: number;
  scale: number;
}

const MediaViewerBoxOrdering: React.FC<MediaViewerBoxOrderingProps> = ({
  boxAnnotations,
  imageHeight,
  imageWidth,
  scale,
}) => {
  const classes = useStyles();
  const gtBoxAnnotations = boxAnnotations.filter(box => !box.isPrediction);
  const predBoxAnnotations = boxAnnotations.filter(box => box.isPrediction);
  const gtSvgPathPoints = gtBoxAnnotations.map(box => {
    return {
      x: (box.xMin + box.xMax) / 2,
      y: (box.yMin + box.yMax) / 2,
    };
  });
  const predSvgPathPoints = predBoxAnnotations.map(box => {
    return {
      x: (box.xMin + box.xMax) / 2,
      y: (box.yMin + box.yMax) / 2,
    };
  });

  return (
    <svg className={classes.svg} width={imageWidth} height={imageHeight}>
      {gtSvgPathPoints.length > 0 && (
        <path
          d={'M' + gtSvgPathPoints.map(point => `${point.x} ${point.y}`).join(' L')}
          stroke="rgb(255, 40, 40)"
          strokeWidth={2 / scale}
          fill="none"
        />
      )}
      {predSvgPathPoints.length > 0 && (
        <path
          d={'M' + predSvgPathPoints.map(point => `${point.x} ${point.y}`).join(' L')}
          stroke="rgb(255, 40, 40)"
          strokeWidth={2 / scale}
          fill="none"
          strokeDasharray={`${5 / scale}, ${5 / scale}`}
        />
      )}
    </svg>
  );
};

export default MediaViewerBoxOrdering;
